import { useState } from 'react'
import { MineralService } from '../services'
import { useMineralsContext } from '../context/minerals/mineralsProvider'
import { MINERALS_ACTIONS } from '../context/minerals/MINERALS_ACTIONS'
import { MINERAL_ACTIONS } from '../context/mineral/MINERAL_ACTIONS'
import { useMineralContext } from '../context/mineral/mineralProvider'
import { toastError } from '../../helper'
import { useSearchParams } from 'react-router-dom'

export default function useMineralsActions() {
  const [searchParams] = useSearchParams()
  const { mineralsDispatch } = useMineralsContext()
  const { mineralDispatch } = useMineralContext()
  const [inProgress, setInProgress] = useState(false)

  async function getMinerals(queryString) {
    try {
      mineralsDispatch({
        type: MINERALS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await MineralService.getMinerals(queryString)
      mineralsDispatch({
        type: MINERALS_ACTIONS.SET_MINERALS,
        payload: {
          minerals: data.minerals,
          pagination: {
            links: data.links,
            first_page: data.first_page,
            last_page: data.last_page,
            current_page: data.current_page,
          },
        },
      })
    } catch (error) {
    } finally {
      mineralsDispatch({
        type: MINERALS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function createMineral(payload) {
    try {
      setInProgress(true)
      const { data } = await MineralService.createMinerals(payload)
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }

  async function editMineral(mineralId, payload) {
    try {
      setInProgress(true)
      const { data } = await MineralService.editMineral(mineralId, payload)
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }
  async function deleteMineral(mineralId) {
    try {
      setInProgress(true)
      const { data } = await MineralService.deleteMineral(mineralId)

      await getMinerals(searchParams.toString())
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }

  async function getMineral(mineralId) {
    try {
      mineralDispatch({
        type: MINERAL_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await MineralService.getMineral(mineralId)
      mineralDispatch({
        type: MINERAL_ACTIONS.SET_MINERAL,
        payload: {
          mineral: data.mineral,
        },
      })
      return data.mineral
    } catch (error) {
    } finally {
      mineralDispatch({
        type: MINERAL_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function getMineralCountryDetails(mineralId, countryId) {
    try {
      const { data } = await MineralService.getMineralCountryDetails(
        mineralId,
        countryId,
      )
      return data.details
    } catch (error) {
    } finally {
    }
  }

  async function getCountries(mineralId) {
    try {
      const { data } = await MineralService.getCountries(mineralId)
      return data.countries
    } catch (error) {}
  }

  async function createMineralDetailsForCountry(mineralId, countryId, payload) {
    try {
      setInProgress(true)
      const { data } = await MineralService.createMineralDetailsForCountry(
        mineralId,
        countryId,
        payload,
      )

      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }
  async function updateMineralDetailsForCountry(mineralId, countryId, payload) {
    try {
      setInProgress(true)
      const { data } = await MineralService.updateMineralDetailsForCountry(
        mineralId,
        countryId,
        payload,
      )
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }
  async function deleteMineralDetailsForCountry(mineralId, countryId) {
    try {
      setInProgress(true)
      const { data } = await MineralService.deleteMineralDetailsForCountry(
        mineralId,
        countryId,
      )
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }

  async function toggleMineralStatus(mineralId) {
    try {
      setInProgress(true)
      const { data } = await MineralService.toggleMineralStatus(mineralId)
      await getMinerals(searchParams.toString())
      return data.message
    } catch (error) {
    } finally {
      setInProgress(false)
    }
  }
  async function createMineralValueChain(mineralId, payload) {
    try {
      setInProgress(true)

      const { data } = await MineralService.createMineralValueChain(
        mineralId,
        payload,
      )
      await getMinerals(searchParams.toString())
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }

  async function updateMineralValueChain(mineralId, payload) {
    try {
      setInProgress(true)

      const { data } = await MineralService.updateMineralValueChain(
        mineralId,
        payload,
      )
      await getMinerals(searchParams.toString())
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }

  return {
    getMinerals,
    createMineral,
    editMineral,
    getMineral,
    deleteMineral,
    getMineralCountryDetails,
    getCountries,
    createMineralDetailsForCountry,
    updateMineralDetailsForCountry,
    deleteMineralDetailsForCountry,
    toggleMineralStatus,
    updateMineralValueChain,
    createMineralValueChain,
    inProgress,
  }
}
